import type { CarnivalGameState, SelectSinAction } from "../types";

export function applySelectSin(
  state: CarnivalGameState,
  action: SelectSinAction,
): CarnivalGameState {
  const hand = state.handsByPlayerId[action.playerId] ?? [];
  const nextState: CarnivalGameState = {
    ...state,
    handsByPlayerId: {
      ...state.handsByPlayerId,
      [action.playerId]: hand.filter((sin) => sin !== action.sin),
    },
    selectionsByPlayerId: {
      ...state.selectionsByPlayerId,
      [action.playerId]: action.sin,
    },
  };

  const allSelected = nextState.players.every(
    (player) => nextState.selectionsByPlayerId[player.playerId] != null,
  );
  if (!allSelected) return nextState;

  return { ...nextState, phase: "REVEAL_RESOLVE" };
}
